export default __webpack_public_path__ + "images/474683280ed5caf334b725424e3aeaa6.svg";